import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { PairTrend } from '@root/entities/pair/ui'

import type { PairModel } from '@root/entities/pair'

type FavoriteCurrencyCellProps = {
  value: PairModel
}

export const FavoriteMcCell: React.FC<FavoriteCurrencyCellProps> = React.memo(
  ({ value }) => {
    const [marketCapUsd] = useAtom(value.marketCapUsd)
    const [priceChange] = useAtom(value.stats['1D'].priceChange)

    return (
      <Root>
        <Numeric
          value={marketCapUsd}
          preset="currency-amount-short"
          currency="$"
        />
        <Trend changePercents={priceChange.toNumber()} showPercents />
      </Root>
    )
  },
)

const Root = styled.div`
  color: var(--text-11);

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const Trend = styled(PairTrend)`
  font-size: 11px;
  justify-content: start;
  gap: 1px;
`
